export const OFFICE_PREVIEW_EXTENSIONS = ['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx'];
export const IMAGE_PREVIEW_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
export const DOCX_PAGE_WIDTH = 816;

export interface SharePreviewProps {
  url: string;
  filename?: string;
  barBackgroundColor?: string;
  logo?: string;
}

/** Read-only Office embed (no ribbon). view.aspx shows the full editor chrome. */
export const getOfficePreviewEmbedUrl = (fileUrl: string): string => {
  const params = new URLSearchParams({
    src: fileUrl,
    wdPrint: '0',
    wdEmbedCode: '0',
  });
  return `https://view.officeapps.live.com/op/embed.aspx?${params}`;
};

const safeDecodeURIComponent = (value = ''): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const getFileExtension = (filename = '', fileUrl = ''): string => {
  const cleanName = filename.split('?')[0].split('#')[0];
  if (cleanName.includes('.')) {
    return cleanName.split('.').pop()?.toLowerCase() ?? '';
  }

  const decodedUrl = safeDecodeURIComponent(fileUrl).split('?')[0].split('#')[0];
  if (decodedUrl.includes('.')) {
    return decodedUrl.split('.').pop()?.toLowerCase() ?? '';
  }

  return '';
};

/** Symbol/Wingdings bullet glyphs from docx-preview do not render reliably on macOS. */
export const fixDocxBulletStyles = (container: HTMLElement): void => {
  container.querySelectorAll('style').forEach((styleEl) => {
    styleEl.textContent = (styleEl.textContent ?? '').replace(
      /(p\.attachment-docx-content-num-[\w-]+:before\s*\{)([^}]*)\}/gi,
      (match, opener, body) => {
        if (/content:\s*"[^"]*counter\(/i.test(body) || !/counter-increment/i.test(body)) {
          return match;
        }

        const fixedBody = body
          .replace(/font-family:\s*[^;]+;/gi, '')
          .replace(
            /content:\s*"[^"]*";/i,
            'content: "\\2022\\00a0"; font-family: Arial, Helvetica, sans-serif; font-weight: 800;'
          );

        return `${opener}${fixedBody}}`;
      }
    );
  });
};
